module.exports = __webpack_public_path__ + "static/img/icon-weici.ae385457.jpg";